module.exports = __webpack_public_path__ + "static/img/preview-03.c5c41f1f.webp";